<template>
  <section class="content">
  <div>
  <v-app>
  <v-container>
    <v-layout row align-center justify-center>
      <v-flex xs8>
          <v-alert value="info" v-if="internalUser == 1" type="info" outline>
            <span> Password update is only available for external users </span>
          </v-alert>
          <v-card flat v-if="internalUser == 0">
            <v-alert
              value="error" v-if="error"
              type="warning"
              outline
            > <span> {{ error }} </span>
            </v-alert>
            <v-card-title primary-title>
              <h3 class="headline mb-2">Update Password</h3>
            </v-card-title>
             <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  name="email"
                  label="Username"
                  v-model="user.email"
                  readonly
                  required>
                </v-text-field>
                <v-text-field
                  name="password"
                  label="Password"
                  v-model="user.password"
                  :type="'password'"
                  :rules="passwordRules"
                  required>
                </v-text-field>
                <v-list v-if="passwordValidationError">
                    <template v-for="(item, index) in passwordErrors">
                      <v-list-item color="error" :key="index">
                        <v-list-item-content>
                          {{ item }}
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                </v-list>
                <v-text-field
                  name="confirmPassword"
                  label="Confirm Password"
                  v-model="user.confirmPassword"
                  :type="'password'"
                  :rules="confirmPasswordRules"
                  required>
                </v-text-field>
             <v-card-actions>
                <v-btn @click="updatePassword" primary>Update Password</v-btn>
             </v-card-actions>
            </v-form>
          </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  </v-app>
 </div>
</section>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'UpdatePassword',
  data: function () {
    return {
      userName: '',
      response: '',
      error: '',
      user: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      internalUser: 0,
      valid: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length > 7) || 'Password length should be atleast 8 characters'
      ],
      confirmPasswordRules: [
        v => !!v || 'Confirm Password Field is required',
        v => (v && v === this.user.password) || 'Confirm Password must match password field'
      ],
      passwordValidationError: false,
      passwordErrors: []
    }
  },
  mounted () {
    this.internalUser = store.state.user.internalUser
    var localUserString = window.localStorage.getItem('user') || 'null'
    console.log(localUserString)
    var localUser = JSON.parse(localUserString)
    this.user.email = localUser.username
    this.internalUser = localUser.internalUser
  },
  methods: {
    toggleLoading () {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse () {
      this.response = ''
    },
    updatePassword () {
      this.message = ''
      this.error = ''
      this.passwordErrors = []
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/user/updatepassword'
        var token = store.state.token
        axios.post(url, this.user, {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            if (response.data.valid === false) {
              this.passwordErrors = response.data.passwordErrors
              console.log('Error is ' + this.passwordErrors)
              this.passwordValidationError = true
              return
            }

            if (response.data.error === true) {
              console.log(response.data.message)
              // this.user.email = store.user.userName
              this.error = response.data.message
              return
            }
            this.logout()
            window.location = '/login?message=' + response.data.message

            this.$refs.form.reset()
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            this.error = error.response
          })
      }
    },
    logout () {
      var url = config.serverURI + '/token/logout'
      console.log(this.user)
      axios.post(url, this.user, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          console.log('Update Response:', response)
          this.message = response.data.message
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          var data = error.response.data
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.message
          }
        })
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)
      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
      }
      this.$router.push('/login')
    }
  }
}

</script>
<style>

</style>
